/* Start of resources collection */

/*

    "REPLACEWITHCATEGORYKEY2": {
      "name": "CATEGORYNAME",
      "description": "CATEGORYDESCRIPTION",
        "resources": [
        {
          "name": "RESOURCENAME",
          "description": "RESOURCEDESCRIPTION",
          "website": "RESOURCEURL",
          "logo": "RESOURCEIMAGEFILENAME"
        },
        {
          "name": "RESOURCENAME",
          "description": "RESOURCEDESCRIPTION",
          "website": "RESOURCEURL",
          "logo": "RESOURCEIMAGEFILENAME"
        },
        {
          "name": "RESOURCENAME",
          "description": "RESOURCEDESCRIPTION",
          "website": "RESOURCEURL",
          "logo": "RESOURCEIMAGEFILENAME"
        },
        {
          "name": "RESOURCENAME",
          "description": "RESOURCEDESCRIPTION",
          "website": "RESOURCEURL",
          "logo": "RESOURCEIMAGEFILENAME"
        }
      ]
    }

*/

var resourceCollection =  {
    "gettingstarted": {
      "name": "Getting Started",
      "description": "Resources for beginners",
        "resources": [
        {
          "name": "8-week beginner's guide",
          "description": "Designed to get you to the point where you can run 30 minutes at a relaxed pace",
          "website": "http://www.runnersworld.com/training/the-8-week-beginners-guide",
          "logo": "runnersworld.jpeg"
        },
        {
          "name": "How to start running",
          "description": "Already in the habit of regular exercise? Want to add running to your routine?",
          "website": "http://www.runnersworld.com/the-starting-line/start-running",
          "logo": "runnersworld.jpeg"
        },
        {
          "name": "Ultimate guide to running",
          "description": "The Beginners Corner section of Strength Running will show you how to start running",
          "website": "http://strengthrunning.com/how-to-start-running/",
          "logo": "strengthrunning.jpg"
        },
        {
          "name": "Here's how to start running",
          "description": "Here's How To Start Running, Stick With It, And Not Totally Hate It",
          "website": "https://www.buzzfeed.com/sallytamarkin/heres-how-to-actually-start-running-if-youre-a-total-beginne",
          "logo": "buzzfeed.png"
        },
         {
          "name": "Beginner's guide to running",
          "description": "Establish a solid foundation for your future development as a runner",
          "website": "http://www.active.com/running/articles/beginner-s-guide-to-running",
          "logo": "active.jpg"
        },
         {
          "name": "5K training plan",
          "description": "Couch to 5K: A running plan for beginners",
          "website": "http://www.nhs.uk/Livewell/c25k/Pages/couch-to-5k.aspx",
          "logo": "couchto5k.png"
        },
         {
          "name": "How to start running",
          "description": "Starting a new running habit doesn’t have to be hard (The New York Times)",
          "website": "http://www.nytimes.com/well/guides/how-to-start-running",
          "logo": "nytimes.jpg"
        }
      ]
    },
    "clothing": {
      "name": "Running clothing",
      "description": "Clothing for men & women",
        "resources": [
        {
          "name": "What to wear",
          "description": "Expert advice about the right stuff to wear (Runner's World)",
          "website": "http://www.runnersworld.com/what-to-wear",
          "logo": "runnersworld.jpeg"
        },
        {
          "name": "Shoe search",
          "description": "Find the right kind of shoe for you (Runner's World)",
          "website": "http://www.runnersworld.com/shoesearch",
          "logo": "runnersworld.jpeg"
        },
        {
          "name": "Selecting the best shoes",
          "description": "Running 101: How To Select The Best Pair Of Running Shoes",
          "website": "http://running.competitor.com/2014/09/shoes-and-gear/running-101-how-to-select-the-best-pair-of-running-shoes_49598",
          "logo": "competitor.jpg"
        },
        {
          "name": "Decathlon",
          "description": "Sporting retailer operating in 38 countries",
          "website": "https://www.decathlon.com",
          "logo": "decathlon.png"
        },
                {
          "name": "Men's long sleeve tops",
          "description": "Find tops for every budget, from high-performance fabrics to basics",
          "website": "https://www.amazon.co.uk/gp/search?ie=UTF8&camp=1634&creative=6738&index=sports&keywords=men%20long%20sleeve%20running%20top&linkCode=ur2&tag=guill0e-21",
          "logo": "amazon.jpg"
        },
                {
          "name": "Women's long sleeve tops",
          "description": "Find tops for every budget, from high-performance fabrics to basics",
          "website": "https://www.amazon.co.uk/gp/search?ie=UTF8&camp=1634&creative=6738&index=sports&keywords=women%20long%20sleeve%20running%20top&linkCode=ur2&tag=guill0e-21",
          "logo": "amazon.jpg"
        },
                {
          "name": "Men's short sleeve tops",
          "description": "Find tops for every budget, from high-performance fabrics to basics",
          "website": "https://www.amazon.co.uk/gp/search?ie=UTF8&camp=1634&creative=6738&index=sports&keywords=men%20short%20sleeve%20running%20top&linkCode=ur2&tag=guill0e-21",
          "logo": "amazon.jpg"
        },
                {
          "name": "Women's short sleeve tops",
          "description": "Find tops for every budget, from high-performance fabrics to basics",
          "website": "https://www.amazon.co.uk/gp/search?ie=UTF8&camp=1634&creative=6738&index=sports&keywords=women%20short%20sleeve%20running%20top&linkCode=ur2&tag=guill0e-21",
          "logo": "amazon.jpg"
        },
                {
          "name": "Men's long trousers/tights",
          "description": "Perfect for winter or cold, rainy days",
          "website": "https://www.amazon.co.uk/gp/search?ie=UTF8&camp=1634&creative=6738&index=sports&keywords=men%20long%20running%20tights%20trousers&linkCode=ur2&tag=guill0e-21",
          "logo": "amazon.jpg"
        },
                {
          "name": "Women's long tights",
          "description": "Perfect for winter or cold, rainy days",
          "website": "https://www.amazon.co.uk/gp/search?ie=UTF8&camp=1634&creative=6738&index=sports&keywords=women%20long%20running%20tights%20trousers&linkCode=ur2&tag=guill0e-21",
          "logo": "amazon.jpg"
        },
                {
          "name": "Men's running shorts",
          "description": "Find the best fitting and looking shorts here",
          "website": "https://www.amazon.co.uk/gp/search?ie=UTF8&camp=1634&creative=6738&index=sports&keywords=men%20running%20shorts&linkCode=ur2&tag=guill0e-21",
          "logo": "amazon.jpg"
        },
                {
          "name": "Women's running shorts",
          "description": "Find the best fitting and best looking shorts here",
          "website": "https://www.amazon.co.uk/gp/search?ie=UTF8&camp=1634&creative=6738&index=sports&keywords=women%20running%20shorts&linkCode=ur2&tag=guill0e-21",
          "logo": "amazon.jpg"
        },
                {
          "name": "Men's running shoes",
          "description": "Find the best fitting running shoes and tackle any kind of terrain",
          "website": "https://www.amazon.co.uk/gp/search?ie=UTF8&camp=1634&creative=6738&index=sports&keywords=men%20running%20shoes&linkCode=ur2&tag=guill0e-21",
          "logo": "amazon.jpg"
        },
                {
          "name": "Women's running shoes",
          "description": "Find the best fitting running shoes and tackle any kind of terrain",
          "website": "https://www.amazon.co.uk/gp/search?ie=UTF8&camp=1634&creative=6738&index=sports&keywords=women%20running%20shoes&linkCode=ur2&tag=guill0e-21",
          "logo": "amazon.jpg"
        },
                {
          "name": "Men's running socks",
          "description": "Find the most comfortable running socks for all running shoes and terrains",
          "website": "https://www.amazon.co.uk/gp/search?ie=UTF8&camp=1634&creative=6738&index=sports&keywords=men%20running%20socks&linkCode=ur2&tag=guill0e-21",
          "logo": "amazon.jpg"
        },
                {
          "name": "Women's running socks",
          "description": "Find the most comfortable running socks for all running shoes and terrains",
          "website": "https://www.amazon.co.uk/gp/search?ie=UTF8&camp=1634&creative=6738&index=sports&keywords=women%20running%20socks&linkCode=ur2&tag=guill0e-21",
          "logo": "amazon.jpg"
        },
                {
          "name": "Women's sports bras",
          "description": "Discover the best sports bras out there and have more comfortable runs",
          "website": "https://www.amazon.co.uk/gp/search?ie=UTF8&camp=1634&creative=6738&index=sports&keywords=sports%20bra&linkCode=ur2&tag=guill0e-21",
          "logo": "amazon.jpg"
        }
      ]
    },
    "accessories": {
      "name": "Fitness Trackers",
      "description": "Wearable trackers and watches",
        "resources": [
        {
          "name": "Garmin Vivosmart HR+",
          "description": "Tracks heart rate, displays steps, calories, distance, floors climbed, intensity...",
          "website": "http://amzn.to/2ijANSE",
          "logo": "garmin.png"
        },
        {
          "name": "Fitbit Charge 2",
          "description": "Track steps, distance, calories burned, floors climbed, active minutes and hourly activity",
          "website": "http://amzn.to/2hxUBO9",
          "logo": "fitbit.png"
        },
        {
          "name": "Misfit Ray",
          "description": "Misfit Ray is a minimal and versatile tracker.",
          "website": "http://amzn.to/2i8OlgD",
          "logo": "misfit.png"
        },
        {
          "name": "Fitbit Alta",
          "description": "Automatically track how long and how well you sleep and set a silent vibrating alarm",
          "website": "http://amzn.to/2hfxvOx",
          "logo": "fitbit.png"
        },
        {
          "name": "Misfit Shine 2",
          "description": "Track steps, calories, distance, light and deep sleep",
          "website": "http://amzn.to/2hjbqjR",
          "logo": "misfit.png"
        },
        {
          "name": "Jawbone UP3",
          "description": "The simplest way to get credit for your steps, exercise and overall calories",
          "website": "http://amzn.to/2hfxRoq",
          "logo": "jawbone.jpg"
        },
        {
          "name": "Moov Now",
          "description": "A wearable fitness coach that actively monitors your tendencies",
          "website": "http://amzn.to/2iju5MA",
          "logo": "moov.jpg"
        },
        {
          "name": "Xiaomi Mi Band 2",
          "description": "The latest wearable fitness tracker from Chinese hardware giant Xiaomi",
          "website": "http://amzn.to/2hfya2y",
          "logo": "xiaomi.png"
        },
        {
          "name": "Xiaomi Mi Band 1S",
          "description": "Budget step & sleep tracker with heart rate monitoring",
          "website": "http://amzn.to/2hfA0kc",
          "logo": "xiaomi.png"
        },
        {
          "name": "TomTom Touch",
          "description": "TomTom Touch tracks steps, sleep and heart rate and body composition",
          "website": "http://amzn.to/2ijpMAX",
          "logo": "tomtom.png"
        },
        {
          "name": "Garmin Vivoactive HR",
          "description": "GPS smart watch with a sunlight-readable, high-resolution colour touchscreen",
          "website": "http://amzn.to/2hxPqOo",
          "logo": "garmin.png"
        },
        {
          "name": "Samsung Gear Fit2",
          "description": "A GPS fitness band you can run with while your phone stays at home.",
          "website": "http://amzn.to/2hfCqPE",
          "logo": "samsung.png"
        },
        {
          "name": "Skagen Hagen",
          "description": "Hybrid smartwatch that marries the best of modern innovation with classic watchmaking",
          "website": "http://amzn.to/2hfrK3F",
          "logo": "skagen.jpg"
        },
        {
          "name": "Microsoft Band 2",
          "description": "Unique lifestyle tool that helps keep you on track and productive",
          "website": "http://amzn.to/2i8UVno",
          "logo": "microsoft.jpg"
        },
        {
          "name": "Under Armour UA Band",
          "description": "UA Band measures sleep, resting heart rate, steps & more",
          "website": "http://amzn.to/2hy21RJ",
          "logo": "underarmour.jpg"
        },
        {
          "name": "Withings Go",
          "description": "Withings Go Activity, Swim and Sleep Tracker",
          "website": "http://amzn.to/2hfCgHX",
          "logo": "withings.png"
        }
      ]
    },
    "races": {
      "name": "Races",
      "description": "5K, 10K, Half Marathons and Marathons",
      "resources": [
        {
          "name": "MyNextRun",
          "description": "Online running calendar with nearly 15000 events",
          "website": "https://www.mynextrun.com/",
          "logo": "mynextrun.png"
        },
        {
          "name": "Ahotu Marathons",
          "description": "International running calendar and runners' resources",
          "website": "http://marathons.ahotu.com/",
          "logo": "ahotumarathons.png"
        },
        {
          "name": "Runner's World",
          "description": "Race finder for USA",
          "website": "http://www.runnersworld.com/race-finder",
          "logo": "runnersworld.jpeg"
        },
        {
          "name": "HalfMarathons.net",
          "description": "Half marathon finder",
          "website": "http://www.halfmarathons.net/",
          "logo": "halfmarathonsnet.jpeg"
        },
        {
          "name": "New York City Marathon",
          "description": "11 May 2017",
          "website": "http://www.tcsnycmarathon.org/",
          "logo": "tcsnyc.png"
        },
        {
          "name": "Chicago Marathon",
          "description": "8 October 2017",
          "website": "https://www.chicagomarathon.com/",
          "logo": "chicagomarathon.png"
        },
        {
          "name": "Marathon de Paris",
          "description": "9 April 2017",
          "website": "http://www.schneiderelectricparismarathon.com/",
          "logo": "marathonparis.jpg"
        },
        {
          "name": "London Marathon",
          "description": "23 April 2017",
          "website": "https://www.virginmoneylondonmarathon.com/",
          "logo": "londonmarathon.jpg"
        },
        {
          "name": "Tokyo Marathon",
          "description": "26 February 2017",
          "website": "http://www.marathon.tokyo/en/",
          "logo": "tokyomarathon.png"
        },
        {
          "name": "Boston Marathon",
          "description": "17 April 2017",
          "website": "http://www.baa.org/races/boston-marathon.aspx",
          "logo": "bostonmarathon.jpg"
        },
        {
          "name": "Berlin Marathon",
          "description": "24 September 2017",
          "website": "http://www.bmw-berlin-marathon.com/",
          "logo": "berlinmarathon.png"
        },
        {
          "name": "Osaka Marathon",
          "description": "26 November 2017",
          "website": "http://www.osaka-marathon.com/index_en.html",
          "logo": "osakamarathon.jpg"
        },
        {
          "name": "Honolulu Marathon",
          "description": "10 December 2017",
          "website": "http://www.honolulumarathon.org/",
          "logo": "honolulumarathon.jpg"
        },
        {
          "name": "LA Marathon",
          "description": "19 March 2017",
          "website": "http://www.lamarathon.com/",
          "logo": "lamarathon.jpg"
        }
      ]
    },
    "apps": {
      "name": "Useful Apps",
      "description": "Apps for planning and tracking runs",
        "resources": [
        {
          "name": "Strava",
          "description": "Run and cycling tracking on the social network for athletes",
          "website": "https://www.strava.com/",
          "logo": "strava.jpg"
        },
        {
          "name": "MapMyRun",
          "description": "Running, running maps, running routes and running community",
          "website": "http://www.mapmyrun.com/",
          "logo": "mapmyrun.jpg"
        },
        {
          "name": "RunKeeper",
          "description": "Track your runs, walks and more",
          "website": "https://runkeeper.com/index",
          "logo": "runkeeper.jpg"
        },
        {
          "name": "Nike+ Run Club",
          "description": "Your perfect running partner",
          "website": "https://www.nike.com/us/en_us/p/activity",
          "logo": "nikeplus.jpg"
         },
        {
          "name": "Couch to 5K",
          "description": "Easy, fun 5K training plan for beginner runners",
          "website": "http://www.active.com/mobile/couch-to-5k-app",
          "logo": "couchto5k.png"
         },
        {
          "name": "Endomondo",
          "description": "Free your endorphins running, walking, cycling and more",
          "website": "https://www.endomondo.com/",
          "logo": "endomondo.jpg"
         },
        {
          "name": "Runtastic",
          "description": "Running, cycling & fitness GPS tracker",
          "website": "https://www.runtastic.com/",
          "logo": "runtastic.png"
         },
        {
          "name": "iSmoothRun",
          "description": "GPS/pedometer tracker for runners",
          "website": "http://www.ismoothrun.com/",
          "logo": "ismoothrun.png"
         },
        {
          "name": "Wahoo fitness",
          "description": "Connected cycling, running and fitness",
          "website": "http://www.wahoofitness.com/",
          "logo": "wahoofitness.jpg"
         },
        {
          "name": "Runmeter",
          "description": "iPhone app for running, cycling, walking and more",
          "website": "http://abvio.com/runmeter/",
          "logo": "runmeter.png"
        }
      ]
    },
    "parkrun": {
      "name": "Parkrun",
      "description": "Weekly 5K runs all over the world",
        "resources": [
        {
          "name": "parkrun Australia",
          "description": "Free weekly 5km timed runs in Australia",
          "website": "http://www.parkrun.com.au/",
          "logo": "parkrun.jpg"
        },
        {
          "name": "parkrun Canada",
          "description": "Free weekly 5km timed runs in Canada",
          "website": "http://www.parkrun.ca/",
          "logo": "parkrun.jpg"
        },
        {
          "name": "parkrun Denmark",
          "description": "Free weekly 5km timed runs in Denmark",
          "website": "http://www.parkrun.dk/",
          "logo": "parkrun.jpg"
        },
        {
          "name": "parkrun France",
          "description": "Free weekly 5km timed runs in France",
          "website": "http://www.parkrun.fr/",
          "logo": "parkrun.jpg"
        },
        {
          "name": "parkrun Ireland",
          "description": "Free weekly 5km timed runs in Ireland",
          "website": "http://www.parkrun.ie/",
          "logo": "parkrun.jpg"
        },
        {
          "name": "parkrun Italy",
          "description": "Free weekly 5km timed runs in Italy",
          "website": "http://www.parkrun.it/",
          "logo": "parkrun.jpg"
        },
        {
          "name": "parkrun New Zealand",
          "description": "Free weekly 5km timed runs in New Zealand",
          "website": "http://www.parkrun.co.nz/",
          "logo": "parkrun.jpg"
        },
        {
          "name": "parkrun Poland",
          "description": "Free weekly 5km timed runs in Poland",
          "website": "http://www.parkrun.pl/",
          "logo": "parkrun.jpg"
        },
        {
          "name": "parkrun Russia",
          "description": "Free weekly 5km timed runs in Russia",
          "website": "http://www.parkrun.ru/",
          "logo": "parkrun.jpg"
        },
        {
          "name": "parkrun Singapore",
          "description": "Free weekly 5km timed runs in Singapore",
          "website": "http://www.parkrun.sg/",
          "logo": "parkrun.jpg"
        },
        {
          "name": "parkrun South Africa",
          "description": "Free weekly 5km timed runs in South Africa",
          "website": "http://www.parkrun.co.za/",
          "logo": "parkrun.jpg"
        },
        {
          "name": "parkrun Sweden",
          "description": "Free weekly 5km timed runs in Sweden",
          "website": "http://www.parkrun.se/",
          "logo": "parkrun.jpg"
        },
         {
          "name": "parkrun UK",
          "description": "Free weekly 5km timed runs in UK",
          "website": "http://www.parkrun.org.uk/",
          "logo": "parkrun.jpg"
        },
         {
          "name": "parkrun USA",
          "description": "Free weekly 5km timed runs in USA",
          "website": "http://www.parkrun.us/",
          "logo": "parkrun.jpg"
        }  
      ]
    },
    "injuries": {
      "name": "Injury Prevention",
      "description": "Resources about injury prevention",
        "resources": [
        {
          "name": "Articles on injury prevention",
          "description": "Learn the best ways to stay injury free (Competitor)",
          "website": "http://running.competitor.com/category/injury-prevention",
          "logo": "competitor.jpg"
        },
        {
          "name": "Preventing running injuries",
          "description": "Learn best running practices, commmon injuries and how to prevent them",
          "website": "http://www.stopsportsinjuries.org/STOP/Prevent_Injuries/Running_Injury_Prevention.aspx",
          "logo": "stopsportsinjuries.jpg"
        },
        {
          "name": "Injury prevention & recovery",
          "description": "The best articles on injury prevention & recovery by Runner's World",
          "website": "http://www.runnersworld.com/tag/injury-prevention-recovery",
          "logo": "runnersworld.jpeg"
        },
        {
          "name": "Injury prevention articles",
          "description": "Use this guide to avoid common aches and pains and perform your best",
          "website": "http://www.active.com/fitness/injury-prevention",
          "logo": "active.jpg"
        },
         {
          "name": "Training articles archive",
          "description": "Learn about common running injuries and how to best avoid them",
          "website": "https://runnersconnect.net/category/running-injury-prevention/",
          "logo": "runnersconnect.png"
        }
      ]
    },
    "websites": {
      "name": "Running Websites",
      "description": "General running and fitness websites",
        "resources": [
        {
          "name": "Runner's World",
          "description": "Shoe reviews, training advice, running news, nutrition tips",
          "website": "http://www.runnersworld.com/",
          "logo": "runnersworld.jpeg"
        },
        {
          "name": "Active",
          "description": "Find & Register for Races, Local Events & Things to Do",
          "website": "http://www.active.com/",
          "logo": "active.jpg"
        },
        {
          "name": "Competitor",
          "description": "Marathon Training Plans, Running Shoe Reviews, Nutrition",
          "website": "http://running.competitor.com/",
          "logo": "competitor.jpg"
        },
        {
          "name": "Men's Fitness",
          "description": "A source for exercise, health and nutrition advice",
          "website": "http://www.mensfitness.com/topics/running",
          "logo": "mensfitness.jpg"
        },
        {
          "name": "Women's Running",
          "description": "Women's running training advice, kit reviews, running shoe reviews and more",
          "website": "http://womensrunning.competitor.com/",
          "logo": "womensrunning.jpg"
        },
        {
          "name": "Fitness",
          "description": "Fitness, beauty, wellness, food and other topics",
          "website": "http://www.fitnessmagazine.com/run/",
          "logo": "fitness.jpg"
        },
        {
          "name": "RunnersConnect",
          "description": "Training plans, training schedules and running programs",
          "website": "https://runnersconnect.net/",
          "logo": "runnersconnect.png"
        }
      ]
    },
    "nutrition": {
      "name": "Nutrition",
      "description": "Information about nutrition and diet",
        "resources": [
        {
          "name": "Articles and recipes",
          "description": "Information regarding running nutrition and healthy eating by Competitor.com",
          "website": "http://running.competitor.com/category/nutrition",
          "logo": "competitor.jpg"
        },
        {
          "name": "Nutrition & weight loss",
          "description": "The best Runner's world articles & recipes to lose weight",
          "website": "http://www.runnersworld.com/nutrition-weight-loss",
          "logo": "runnersworld.jpeg"
        },
        {
          "name": "Meal plans for runners",
          "description": "Getting your training diet spot on will help you go that extra mile",
          "website": "http://www.bbcgoodfood.com/howto/guide/running-nutrition-typical-training-plan",
          "logo": "bbcgoodfood.jpg"
        },
        {
          "name": "Nutrition guide",
          "description": "Fuel your body with the right nutrients to stay in top shape, and perform your best",
          "website": "http://www.active.com/nutrition",
          "logo": "active.jpg"
        },
        {
          "name": "Nutrition for runners",
          "description": "Learn How to Eat for Optimal Performance and Lose Weight",
          "website": "https://runnersconnect.net/nutrition-for-runners/",
          "logo": "runnersconnect.png"
        },
        {
          "name": "The best food for runners",
          "description": "The 15 foods runners need every week for good health and top performance",
          "website": "http://www.runnersworld.com/nutrition/the-best-foods-for-runners",
          "logo": "runnersworld.jpeg"
        },
        {
          "name": "Essential foods for runners",
          "description": "Are you eating the foods you should be for energy, recovery, and fitness?",
          "website": "http://running.competitor.com/2014/06/photos/photos-10-essential-foods-for-runners_11329",
          "logo": "competitor.jpg"
        },
        {
          "name": "Food for before/after a run",
          "description": "Find out how to fuel up before and after your training runs to maximize results",
          "website": "http://www.mensfitness.com/nutrition/what-to-eat/pre-and-post-workout-nutrition-for-runners",
          "logo": "mensfitness.jpg"
        },
        {
          "name": "The best food for runners",
          "description": "Experts to tell us what should be considered the staples of a runner's diet",
          "website": "http://www.huffingtonpost.com/2013/08/16/best-foods-for-runners_n_3762290.html",
          "logo": "huffingtonpost.jpg"
        },
        {
          "name": "Why runners shouldn't diet",
          "description": "Find out why you shouldn't diet (and what to do instead)",
          "website": "http://dailyburn.com/life/health/running-for-weight-loss-diet/",
          "logo": "dailyburn.jpg"
        },
        {
          "name": "Diet plan for runners",
          "description": "Lose pounds by running. Here's the plan for week 1 (Women's Health)",
          "website": "http://www.womenshealthmag.com/fitness/diet-plan-for-runners-week-1",
          "logo": "womenshealth.jpg"
        }
      ]
    }
}
/* End of resources collection */

window.resourceCollection = resourceCollection;


// WEBPACK FOOTER //
// ./src/components/resourceCollection.js